<template>
  <v-card flat :oading="loading" :disabled="loading">
    <v-list dense nav class="menu_dashboard">
      <v-list-item-group color="info">
        <div v-for="(menu, index) in menus" :key="index">
          <v-list-item
            :to="menu.no_action ? '' : { path: menu.path }"
            v-if="menu.type === 'single' && menu.permission"
            :disabled="menu.disabled"
            @click="menu.click_menu ? mudaMenu(menu.click_menu) : ''"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ menu.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-if="menu.type === 'group' && menu.permission"
            :group="menu.path"
            no-action
            :prepend-icon="menu.icon"
            :disabled="menu.disabled"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ menu.name }}</v-list-item-title>
            </template>
            <div v-for="(child, index) in menu.children" :key="index">
              <v-list-item
                v-if="child.type === 'single' && child.permission"
                :to="{ path: child.path }"
                :disabled="child.disabled"
              >
                <v-list-item-icon>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ child.name }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
        </div>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "MenuDashBoardCliente",

  data() {
    return {
      loading: false,
      menus: null,
    };
  },

  computed: {},

  methods: {
    ...mapActions("Componentes", {
      STORE_getAccess: "getAccess",
    }),

    mudaMenu(menu) {
      this.$store.commit("UPDATE_MENUDINAMICO", menu);
    },
  },

  async mounted() {
    this.loading = true;
    this.menus = [
      {
        type: "single",
        name: "Home",
        path: "/cliente/home",
        icon: "mdi-home",
        disabled: false,
        permission: true,
      },
      {
        type: "single",
        name: "Calendário Editorial Mídias Sociais",
        path: "/cliente/midias-sociais/calendario-midias-sociais",
        icon: "mdi-calendar",
        disabled: false,
        permission: true,
      },
      {
        type: "single",
        name: "Atividades",
        path: "/cliente/atividades",
        icon: "mdi-briefcase-edit-outline",
        disabled: false,
        permission: true,
      },
      {
        type: "group",
        name: "Relatorios",
        path: "/cliente/relatorios",
        icon: "mdi-file-chart",
        disabled: false,
        permission: true,
        children: [
          {
            type: "single",
            name: "Relatório Duração das Atividades",
            path: "/cliente/relatorios/atividade",
            icon: "mdi-circle-medium",
            permission: true,
            disabled: false,
          },
        ],
      },
    ];
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.menu_dashboard ::v-deep .v-list-item {
  padding-top: 3px;
  padding-bottom: 3px;
  margin-bottom: 3px;
}

.menu_dashboard ::v-deep .v-list-item .v-list-item__title {
  font-size: 0.9rem !important;
  font-weight: 500;
  line-height: 1rem;
}
</style>
